import { render, staticRenderFns } from "./ModalDelivery.vue?vue&type=template&id=8296b47c&lang=pug&"
import script from "./ModalDelivery.vue?vue&type=script&lang=js&"
export * from "./ModalDelivery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports